import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GmMemberLookUp, GmDealerEligibility, LOYMember } from '@quorum/models/oem-resource';

@Component({
  selector: 'quorum-gm-my-rewards-customer-information',
  templateUrl: './gm-my-rewards-customer-information.component.html',
  styleUrls: ['./gm-my-rewards-customer-information.component.scss'],
})
export class GmMyRewardsCustomerInformationComponent {
  @Input()
  gmMyRewardsData!: {
    memberLookup: GmMemberLookUp;
    accountInformation: LOYMember;
    dealerEligibility: GmDealerEligibility;
    businessId: string;
    dealerCountryCode: string;
    emailAddress: string;
  };
  @Output() closeDialogEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() {}

  closeDialog() {
    this.closeDialogEvent.emit(true);
  }
}
